<h2 mat-dialog-title>{{data.title}}</h2>

<mat-dialog-content [id]="dialogContentId" [innerHtml]="data.content | dompurify"></mat-dialog-content>

<mat-dialog-actions class="dialog">
  <button mat-button mat-dialog-close >{{data.cancelButtonText}}</button>
  <button mat-button mat-dialog-close="true" class="orange-text" cdkFocusInitial>{{data.confirmButtonText}}</button>
</mat-dialog-actions>